import { render, staticRenderFns } from "./SchemeChannelCard.vue?vue&type=template&id=6ffdd912&scoped=true"
import script from "./SchemeChannelCard.vue?vue&type=script&lang=js"
export * from "./SchemeChannelCard.vue?vue&type=script&lang=js"
import style0 from "./SchemeChannelCard.vue?vue&type=style&index=0&id=6ffdd912&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffdd912",
  null
  
)

export default component.exports